export default __webpack_public_path__ + "static/media/01_KeepingDistance.fcbc4917.jpg";